import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { log } from '../../helpers/utils'
import { NoticeStore } from '../../state/NoticeStore'
import BlankCart from './BlankCart'
import CartRows from './CartRows'
import CartTotal from './CartTotal'
import Coupon from './Coupon'
import {
    _KEY,
    _PARENT_KEY,
    getMainProductsFromCart,
} from '../../helpers/checkout'
import Loader from '../Loader'

function CartComponent({ cart, handleCart }) {
    const router = useRouter()

    const [isCheckout, setIsCheckout] = useState(false)
    const [mapped_metas, setMappedMetas] = useState({})
    const [hasSetMappedData, setHasSetMappedData] = useState(false)

    const reset = NoticeStore((state) => state.reset)
    const items = Array.isArray(cart?.items) ? cart.items : []
    const order_id = cart?.order?.id || cart?.store_api_draft_order_id

    const handleCartInside = async (updatedCart) => {
        reset()
        await handleCart(updatedCart)
    }

    const processItems = (items = [], line_items = []) => {
        const mapped_metas = {}

        items.forEach((item) => {
            if (
                !Array.isArray(item?.item_data) ||
                item.item_data.length === 0
            ) {
                return
            }

            const key = item.item_data.find((data) => data.name === _KEY)?.value
            if (!key) {
                return
            }

            const lineItem = line_items.find((line) => {
                const meta_data = Array.isArray(line?.meta_data)
                    ? line.meta_data
                    : []
                const key_object = meta_data.find((data) => data.key === _KEY)
                const parent_key_object = meta_data.find(
                    (data) => data.key === _PARENT_KEY,
                )

                if (parent_key_object) {
                    return (
                        parent_key_object.value === key ||
                        key_object?.value === key
                    )
                }

                return key_object?.value === key
            })

            if (lineItem) {
                mapped_metas[item.key] = lineItem.id
            }
        })

        return mapped_metas
    }

    useEffect(() => {
        const currentItems = Array.isArray(cart?.items) ? cart.items : []
        const currentLineItems = Array.isArray(cart?.order?.line_items)
            ? cart.order.line_items
            : []
        const currentOrderId = cart?.order?.id || cart?.store_api_draft_order_id

        setIsCheckout(router.asPath.includes('checkout'))

        if (currentItems.length === 0) {
            log('no order id', cart)
            setMappedMetas({})
            setHasSetMappedData(true)
            return
        }

        if (!currentOrderId || currentLineItems.length === 0) {
            log('cart order is missing mapped line items', cart)
            setMappedMetas({})
            setHasSetMappedData(true)
            return
        }

        const nextMappedMetas = processItems(currentItems, currentLineItems)
        log('line_items', currentLineItems)
        setMappedMetas(nextMappedMetas)
        log('mapped_metas', nextMappedMetas)
        setHasSetMappedData(true)
    }, [cart, router.asPath])

    if (!hasSetMappedData) {
        return <Loader text="Loading..."></Loader>
    }

    const hasMainCartItems = getMainProductsFromCart({ items }).length > 0

    return (
        <div data-element-id="cart-component">
            {hasMainCartItems ? (
                <>
                    <CartRows
                        cart={{ ...cart, items }}
                        mapped_metas={mapped_metas}
                        afterRemoveItem={handleCartInside}
                        order_id={order_id}
                    />
                    {isCheckout && (
                        <Coupon
                            cart={{ ...cart, items }}
                            afterCouponApply={handleCartInside}
                        />
                    )}
                    {isCheckout && <CartTotal cart={{ ...cart, items }} />}
                </>
            ) : (
                <BlankCart />
            )}
        </div>
    )
}

export default CartComponent
